import React, {useState, useEffect} from "react";
import LeftMenuLayout from '../../layouts/LeftMenuLayout';
import ScrollPageTop from '../../routes/ScrollPageTop'

import moment from 'moment';
import classNames from 'classnames';
import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import Table from 'rc-table';
import Pagination from '../../_utils/pagination.jsx'
import {
   API_ENDPOINT,
   APP_NAME, 
   APP_URL,
   date_format,
   amount_format,
   LIMIT,
   replaceWithBr 
} from '../config/Common'
import ModalView from '../../_utils/ModalView'
import {Links} from '../../routes/PathLink'
import ModalTicketView from './ModalTicketView'
import NoRecords from '../NoRecords'

const MyProposal = () => {
   const [accessToken] = useState(localStorage.getItem('access_token'))
   const [tickets, setTickets] = useState(null)
   const [totalRec, setTotalRec] = useState(null)
   const [currentPage, setCurrentPage] = useState(1)
   const [isOpen, setIsOpen] = useState(false)
   const [ticket, setTicket] = useState(null)
   
   const [metaData, setMetaData] = useState({
      url: `${APP_URL}${Links.MY_PROPOSALS}`,
      title:  `My AMC proposals - ${APP_NAME}`,
      description:'My AMC proposals'
   })

   useEffect(() => {
      getMyProposals(currentPage)
   },[])

   const getMyProposals = (page) => {
      fetch(`${API_ENDPOINT}/get_my_proposals?pg=${page}&limit=${LIMIT}`,{
         method: 'GET',
         headers : {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer '+accessToken, 
         }
      }).then(function (response) {
         return response.json();
      }).then( (result)=> {
         console.log('ticket=====',result)
         setTickets(result.data)
         setTotalRec(result.totalRec)
      })
   }

   const statusBadge = (record: any) => {
      
      return(
         <>
         {
         record.amc_ticket.status === 'open' ?
         <span className={classNames("bg-red-100 text-red-800 border-red-400 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border capitalize")}>{record.amc_ticket.status}</span>
         :
         record.amc_ticket.status === 'closed' ?
         <span className={classNames("bg-green-100 text-green-800 border-green-400 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border capitalize")}>{record.amc_ticket.status}</span>
         :
         <span className={classNames("bg-yellow-100 text-yellow-800 border-yellow-400 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border capitalize")}>{record.amc_ticket.status}</span>
         }
         </>
      )
   }

   const getMachineName = (record: any) => {
      return(
         <>
         {
         record.amc_ticket.package &&
         <p className="text-sm">
            {
            record.amc_ticket.package.machine.parent &&
            <span>{record.amc_ticket.package.machine.parent.cat_name}, </span>
            }
            {record.amc_ticket.package.machine.cat_name}
         </p>
         }
         </>
      )
   }
   
   const columns = [      
      
      {
         title: 'Ticket',
         dataIndex: '',
         key: 'ticket',
         width: 150,         
         align: 'left',
         render: (tk) => <button onClick={() => openModal(tk)} className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent-hover hover:underline">{tk.amc_ticket.ticket_no}</button>
      },
      {
         title: 'Machine',
         dataIndex: '',
         key: 'status',
         width: 150,         
         align: 'left',
         render: getMachineName
         
      },      
      {
         title: 'Bid Amount',
         dataIndex: '',
         key: 'bid_amount',
         width: 150,         
         align: 'right',
         render: (tk) => <p className="flex justify-end text-sm">{amount_format(tk.bid_amount)}</p>
      },
      {
         title: 'Package Amount',
         dataIndex: '',
         key: 'amount',
         width: 150,         
         align: 'right',
         render: (tk) => <p className="flex justify-end text-sm">{amount_format(tk.amc_ticket.amount)}</p>
      },
      {
         title: 'Bid Date',
         dataIndex: '',
         key: 'enddate',
         width: 150,         
         align: 'left',         
         render: (tk) => <p className="text-sm">{date_format(tk.created_at)}</p>,
         
      },
      
   ]

   const onPagination = (page, limit) => { 
      
      getMyProposals(page)
      setCurrentPage(page)

      window.scrollTo({
         top: 0,
         left: 0,
         behavior: "smooth"
      });
   }

   const closeModal = () => {
      setIsOpen(false)
   }
   const openModal = (item) => {
      //console.log(item)
      setTicket(item)
      setIsOpen(true)
   }

   return(
      <ScrollPageTop>
         <ReactSEOMetaTags
				render={(el: React.ReactNode) => <Helmet>{el}</Helmet>}
				website={{ ...metaData }}
			/>
         <LeftMenuLayout>
            <div style={{overflow: 'hidden'}} className={classNames('w-full py-5 bg-light shadow rounded')}>
               <h1 className="ml-6 text-lg text-heading sm:text-xl">
					My Proposals
					</h1>
               {
            totalRec > 0 ?
               <div className="mt-6">
                  <Table 
                     columns={columns} 
                     data={tickets} 
                     className="orderDetailsTable w-full"
                     rowKey={(record:any) => record.ticket_id}
                     scroll={{ x: 800 }}
                  />
                  <div className="mt-5 flex items-center justify-end">
                  {
                  totalRec > LIMIT &&
                  <Pagination
                     total={totalRec}
                     current={currentPage}
                     pageSize={LIMIT}
                     onChange={onPagination}
                  />
                  }
                  </div>
               </div>
            :
            <NoRecords message="You are not bid on any AMC's yet." />
            }
         </div>
         {
         ticket &&
         <ModalView open={isOpen} onClose={closeModal}>
            <ModalTicketView ticket={ticket.amc_ticket} desc={ticket.description} />
            
         </ModalView>
         }  
         </LeftMenuLayout>
      </ScrollPageTop>
   );
}

export default MyProposal